import React, { useState, useEffect , useRef } from 'react';
import { classNames } from 'primereact/utils';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
//import { Clientes } from '../api/ProductService.tsx';
import { getProductos,addProducto , updateProducto, eliminarProducto ,getNumeroNextProducto } from '../api/productoService';//getClientes
import { Button } from 'primereact/button';
import { Toolbar } from 'primereact/toolbar'; 
import { Dialog } from 'primereact/dialog';
import { InputText } from 'primereact/inputtext';
import { Toast } from 'primereact/toast';
import { MultiSelect } from 'primereact/multiselect';
import { InputTextarea } from 'primereact/inputtextarea';
import { Dropdown } from 'primereact/dropdown';
import {getImpuestos}  from "../api/monedaFormaPagoService"
import { Tag } from 'primereact/tag';
import { AutoComplete } from 'primereact/autocomplete';
import {searchMedidas, getUnidadesMedidas} from '../api/unidadMedidaService'

import { RadioButton } from 'primereact/radiobutton';
function MainProductosServicios() {
   let emptyProducto = {
        _id: null, 
        noProducto:null,
        nombre:'',
        descripcion:'',
        precioUnitario:null,
        unidad:'',
        peso:'',
        tipo:''  ,
        impuestos:[],
    };

    const tipo = [
    { name: 'Producto', code: 'Producto' },
    { name: 'Servicio', code: 'Servicio' }
    // { name: 'EUA', code: 'US' }
    ];

    const [productos, setProductos] = useState([]);
    const [producto, setProducto] = useState(emptyProducto);

    const [deleteProductoDialog, setDeleteProductoDialog] = useState(false);
    const [deleteProductosDialog, setDeleteProductosDialog] = useState(false);

    const [productoDialog, setProductoDialog] = useState(false);    
    const [submitted, setSubmitted] = useState(false);

    const [selectedProductos, setSelectedProductos] = useState(null);
    const toast = useRef(null);
    const dt = useRef(null);

    const [impuestos, setImpuestos] = useState([]);

    const [contactoDialog, setContactoDialog] = useState(false);   
    const [first, setFirst] = useState(0); // índice inicial de la página
    const rows = 10; // registros por página
    const rowNumberTemplate = (rowData, options) => {
        return first + options.rowIndex + 1;
    };

    const [medidaSeleccionada, setMedidaSeleccionada] = useState(null);
    const [medidasFiltradas, setMedidasFiltradas] = useState([]);
    const [medidas, setMedidas] = useState([]);          // todas las medidas precargadas
    // const [tipoProducto, setTipoProducto] = useState('');


  useEffect(() => {
    const fetchData = async () => {
      const data = await getProductos();
      //console.log('CLIENTES DESDE EL BACKEND:', data);// 👈 aquí revisamos qué viene
      setProductos(data);
    };

    fetchData();
  }, []);
  
   useEffect(() => {
    const fetchData = async () => {
      const data = await getImpuestos();
      console.log(data);
      //console.log('CLIENTES DESDE EL BACKEND:', data);// 👈 aquí revisamos qué viene
      setImpuestos(data);
    };

    fetchData();
  }, []);
  useEffect(() => {
    const fetchMedidas = async () => {
        try {
            const data = await getUnidadesMedidas(); // 👈 aquí usas tu endpoint que trae TODAS
            setMedidas(data);
        } catch (error) {
            console.error("Error al cargar medidas:", error);
        }
    };

    fetchMedidas();
}, []);


  const buscarMedidas = async (event) => {
    try {
        //console.log('Entro');
        // const data = await searchMedidas(event.query); // 👈 recibe el texto escrito
        // console.log(data);
        // setMedidasFiltradas(data);
         let query = event.query.toLowerCase();
            let filtradas = medidas.filter((m) =>
        m.descripcion.toLowerCase().includes(query)
    );
    setMedidasFiltradas(filtradas);
    } catch (error) {
        console.error("Error al buscar medidas:", error);
    }
};

    
    const openNew =async () => {
        setProducto(emptyProducto);
        setSubmitted(false);
        setProductoDialog(true);

        try{
        const data = await getNumeroNextProducto(); // consulta al backend
        setProducto((prev) => ({ ...prev, noProducto: data.productoId })); // asigna el noCliente
        console.log(data);
        setProductoDialog(true);
        }
        catch(error)
        {
            toast.current.show({
            severity: "error",
            summary: "Error",
            detail: "No se pudo generar el número de cliente",
            life: 3000,
        });
        }


    };

    const hideDialog = () => {
        setSubmitted(false);
        setProductoDialog(false);
    };

const exportCSV = () => {
        dt.current.exportCSV();
    };
const leftToolbarTemplate = () => {
        return (
            <div className="flex flex-wrap gap-2">
                <Button label="Agregar Producto / Servicio" icon="pi pi-plus" severity="success" onClick={openNew} />
                <Button label="Exportar" icon="pi pi-upload" className="p-button-help" onClick={exportCSV}/>
                {/* <Button label="Delete" icon="pi pi-trash" severity="danger" onClick={confirmDeleteSelected} disabled={!selectedProducts || !selectedProducts.length} /> */}
            </div>
        );
    };
    
    
    /*Guardar Producto*/
    const saveProducto = async () => {
        setSubmitted(true);

        if (producto.nombre) {        
        try{
             let _productos = [...productos];
            let _producto = { ...producto };

            if (producto._id) {
                // aquí irá el código de actualización más adelante
                //console.log(cliente._id);
                const updated = await updateProducto(_producto._id, _producto);
                const index = findIndexById(_producto._id);
                _productos[index] = updated;
            } else {
               const inserted = await addProducto(_producto);
                _productos.push(inserted);
            }
        const dataActualizada = await getProductos();   
        setProductos(dataActualizada);
        setProductoDialog(false);
        setProducto(emptyProducto);
        toast.current.show({ severity: 'success', summary: 'Éxito', detail: 'Producto guardado', life: 3000 });

        }
        catch (error) {
       console.error('Error al guardar producto:', error);
      toast.current.show({ severity: 'error', summary: 'Error', detail: error.response.data.error, life: 3000 });
    
    }
}
    };

  const deleteProducto = async ()  => {
     try {
        await eliminarProducto(producto._id); // usa el _id de Mongo
        const dataActualizada = await getProductos();
        setProductos(dataActualizada);
        setDeleteProductoDialog(false);
        setProducto(emptyProducto);
        toast.current.show({ severity: 'success', summary: 'Éxito', detail: 'Producto eliminado', life: 3000 });
    } catch (error) {
        console.error('Error al eliminar producto:', error);
        toast.current.show({ severity: 'error', summary: 'Error', detail: 'No se pudo eliminar el producto', life: 3000 });
    }
    };


    /* Editar la informacion del cliente */
    
    const editProducto = (prod) => {
        setProducto({ ...prod });// importante conservar el _id
        // setTipoProducto(producto.tipo); // 👈 aquí sincronizas el radio con el valor del producto
        setProductoDialog(true);
    };

     const confirmDeleteProducto = (producto) => {
        setProducto(producto);
        setDeleteProductoDialog(true);
    };
     const deleteSelectedProductos = () => {
        let _productos = productos.filter((val) => !selectedProductos.includes(val));

        setProductos(_productos);
        setDeleteProductosDialog(false);
        setSelectedProductos(null);
        toast.current.show({ severity: 'success', summary: 'Successful', detail: 'Products Deleted', life: 3000 });
    };
  
    const hideDeleteProductoDialog = () => {
        setDeleteProductoDialog(false);
    };

    const hideDeleteProductosDialog = () => {
        setDeleteProductosDialog(false);
    };
    const findIndexById = (_id) => {
    return productos.findIndex((c) => c._id === _id);
        };


     const onInputChange = (e, name) => {
        const val = (e.target && e.target.value) || '';
        let _producto = { ...producto };

        _producto[`${name}`] = val;

        setProducto(_producto);
    };
 const productoDialogFooter = (
        <React.Fragment>
            <Button label="Cancelar" icon="pi pi-times"  severity='danger'  onClick={hideDialog} />
            <Button label="Guardar" icon="pi pi-check" severity='success' onClick={saveProducto} />
        </React.Fragment>
    );
    const actionBodyTemplate = (rowData) => {
        return (
            <React.Fragment>
                <Button icon="pi pi-pencil" rounded  className="mr-2" onClick={() => editProducto(rowData)} />
                <Button icon="pi pi-trash" rounded  severity="danger" onClick={() => confirmDeleteProducto(rowData)} />
            </React.Fragment>
        );
    };
    const contactBodyTemplate = (rowData) => {
        return (
            <React.Fragment>
                <Button icon="pi pi-users" rounded outlined className="mr-2" onClick={() => editProducto(rowData)} />
            </React.Fragment>
        );
    };
     
    const deleteProductoDialogFooter = (
        <React.Fragment>
            <Button label="No" icon="pi pi-times" outlined onClick={hideDeleteProductoDialog} />
            <Button label="Si" icon="pi pi-check" severity="danger" onClick={deleteProducto} />
        </React.Fragment>
    );
    const deleteProductosDialogFooter = (
        <React.Fragment>
            <Button label="No" icon="pi pi-times" outlined onClick={hideDeleteProductosDialog} />
            <Button label="Si" icon="pi pi-check" severity="danger" onClick={deleteSelectedProductos} />
        </React.Fragment>
    );
    const statusBodyTemplate = (rowData) => {
    const tipoMap = {
        Servicio: { severity: "info", label: "Servicio" },
        Producto: { severity: "warning", label: "Producto" }
    };
console.log(rowData.tipo);
    const { severity, label } = tipoMap[rowData.tipo] || { severity: "danger", label: "Desconocido" };

    return <Tag severity={severity} value={label} rounded />;
        };
    
    const medidaTemplate = (item) => {
    return (
        <div className="flex flex-column p-2 border-b border-gray-200">
            <span className="font-semibold">{item.descripcion}</span>
          <small className="text-gray-500"> {item.descripcion}</small> 
        </div>
    );
    };

    return (
        <>
          <Toast ref={toast} />
    <section className="mission-section" id="productosServicios">
        
        <div class="layout-content-inner">
            <div>
                <nav class="layout-breadcrumb">
                    <ol>
                        <li><a href="/"><i class="pi pi-home"></i></a></li>
                        <li class="layout-breadcrumb-chevron"> / </li>
                        <li>Productos & Servicio</li>
                    </ol>
                </nav>
            </div>

            <div className="card">
                <Toolbar className="mb-4" right={leftToolbarTemplate} ></Toolbar>

                <DataTable  ref={dt} value={productos} paginator rows={rows} first={first}  stripedRows selectionMode="single"
                //rowsPerPageOptions={[5, 10, 25, 50]} 
                onPage={(e) => setFirst(e.first)} // actualiza el índice inicial al cambiar de página
                tableStyle={{ minWidth: '50rem' }}
                emptyMessage="Sin Productos/Servicios">
                    <Column header="#" body={rowNumberTemplate} style={{ width: "50px", textAlign: "center" }} />
                    <Column field="nombre" header="Producto / Servicio" sortable></Column>
                    <Column field="descripcion" header="Descripción" sortable></Column>
                    <Column field="precioUnitario" header="Precio Unitario" sortable></Column>
                    <Column field="tipo" header="Tipo"  body={statusBodyTemplate} sortable></Column>
                    <Column  header="Acciones" body={actionBodyTemplate} exportable={false} style={{ minWidth: '5rem' }}></Column>
                </DataTable>
            </div>

            <Dialog visible={productoDialog} style={{ width: '32rem' }} breakpoints={{ '960px': '75vw', '641px': '90vw' }} header="Datos del Producto / Servicio" modal className="p-fluid" footer={productoDialogFooter} onHide={hideDialog}>
                <div className="formgrid grid">
                    <div className="field col-3">
                        <label htmlFor="noProducto" className="font-bold">#Producto</label>
                        <InputText id="noProducto" value={producto.noProducto} onChange={(e) => onInputChange(e, 'noProducto')} required autoFocus className={classNames({ 'p-invalid': submitted && !producto.noProducto})} />
                    {submitted && !producto.noProducto && <small className="p-error">El #Producto es requerido.</small>}
                     </div>
                     <div className="field col">
                        <label htmlFor="nombre" className="font-bold">Nombre del producto / servicio</label>
                        <InputText id="nombre" value={producto.nombre} onChange={(e) => onInputChange(e, 'nombre')} required autoFocus className={classNames({ 'p-invalid': submitted && !producto.nombre})} />
                    {submitted && !producto.nombre && <small className="p-error">El nombre es requerido.</small>}
                    </div>
                </div>
                 <div className="formgrid grid">
                    <div className="field col">
                        <label htmlFor="descripcion" className="font-bold">Descripción</label>
                        <InputText id="descripcion" value={producto.descripcion} onChange={(e) => onInputChange(e, 'descripcion')} required rows={3} cols={20} />
                    </div> 
                    <div className="field col-3">          
                        <label htmlFor="precioUnitario" className="font-bold">P. Unitario</label>
                        <InputText id="precioUnitario" value={producto.precioUnitario} onChange={(e) => onInputChange(e, 'precioUnitario')} required rows={3} cols={20} />
                    </div>                 
                </div>
                <div className="formgrid grid">
                    <div className="field col">
                         <label htmlFor="tipo" className="font-bold">Tipo</label>  
                         <div className="card flex ">
                            <div className="flex flex-wrap gap-2">
                                <RadioButton inputId="tipo1" name="tipoProducto" value="Producto" 
                                onChange={(e) => setProducto({ ...producto, tipo: e.value })}
                                checked={producto.tipo === 'Producto'}
                                />
                                <label htmlFor="tipo1" className="ml-3">Producto</label>
                                <RadioButton inputId="tipo2" name="tipoProducto" value="Servicio" 
                                onChange={(e) => setProducto({ ...producto, tipo: e.value, peso: '', unidad: '' })}                                    
                                checked={producto.tipo === 'Servicio'}
                                />
                                <label htmlFor="tipo2" className="ml-3">Servicio</label>
                            </div>                            
                         </div>                         
                    </div> 
                </div>
                <div className="formgrid grid">
                     <div className="field col">
                        <label htmlFor="tipomedida" className="font-bold"> Tipo de medida </label>
                        <AutoComplete id="tipomedida"  value={medidaSeleccionada}  suggestions={medidasFiltradas}                        
                        field="nombre" placeholder="Escribe para buscar medida"
                        completeMethod={buscarMedidas} onChange={(e) =>{ setMedidaSeleccionada(e.value);
                            setProducto({...producto, unidad:e.value?e.value.nombre:''});}}                        
                        dropdown  itemTemplate={(item) => (
                            <div>
                                <div><strong>{item.nombre}</strong></div>
                                <small className="text-gray-500">Abreviatura: {item.abreviatura}</small>
                            </div>
                        )} 
                        disabled={producto.tipo === 'Servicio'} // 👈 aquí se desactiva si es servicio
                        />
                     </div>
                     <div className="field col-3">
                        <label htmlFor="peso" className="font-bold">Peso</label>
                        <InputText id="peso" value={producto.peso} onChange={(e) => onInputChange(e, 'peso')} required rows={3} cols={20} 
                        disabled={producto.tipo === 'Servicio'} // 👈 también se desactiva
                        />
                     </div>
                </div>
                 <label htmlFor="Impuestos" className="font-bold">Impuestos</label>
                <div className="formgrid grid"> 
                    <div className="field col">                                          
                        <div className="card flex ">                       
                            <MultiSelect id="impuestos"  optionLabel="abreviatura" 
                            value={producto.impuestos}   // ✅ ligamos a producto.impuestos
                            onChange={(e) => setProducto({ ...producto, impuestos: e.value })} // ✅ actualizamos producto
                            options={impuestos}                        
                            itemTemplate={(option) => `${option.abreviatura}  ${option.porcentaje} %`}
                            valueTemplate={(option, props) => option ? `${option.abreviatura}  ${option.porcentaje} %` : props.placeholder}
                            placeholder="Seleccione"  className="w-full md" display="chip" />
                        </div>  
                    </div>             
                </div>
            </Dialog>

            {/* <Dialog visible={contactoDialog} style={{ width: '32rem' }} breakpoints={{ '960px': '75vw', '641px': '90vw' }} header="Contactos" modal className="p-fluid" footer={productoDialogFooter} onHide={hideDialog}>
<div className="field"></div>
            </Dialog> */}

            <Dialog visible={deleteProductoDialog} style={{ width: '32rem' }} breakpoints={{ '960px': '75vw', '641px': '90vw' }} header="Confirmar" modal footer={deleteProductoDialogFooter} onHide={hideDeleteProductoDialog}>
                <div className="confirmation-content">
                    <i className="pi pi-exclamation-triangle mr-3" style={{ fontSize: '2rem' }} />
                    {producto && (
                        <span>
                            ¿Seguro de eliminar el registro <b>{producto.nombre}</b>?
                        </span>
                    )}
                </div>
            </Dialog>

            <Dialog visible={deleteProductosDialog} style={{ width: '32rem' }} breakpoints={{ '960px': '75vw', '641px': '90vw' }} header="Confirmar" modal footer={deleteProductosDialogFooter} onHide={hideDeleteProductosDialog}>
                <div className="confirmation-content">
                    <i className="pi pi-exclamation-triangle mr-3" style={{ fontSize: '2rem' }} />
                    {producto && <span>Are you sure you want to delete the selected products?</span>}
                </div>
            </Dialog>
        </div>
    </section>
        </>
      
    );
}
export default MainProductosServicios;        